// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchBar_wrapper__Ven9c","icon":"SearchBar_icon__tOnGH","input":"SearchBar_input__3xZrx","kbd":"SearchBar_kbd__EQlwj"};